import React from 'react'
import { css } from '@emotion/react'
import { colors, Button } from 'plume-ui'
import { A } from './A'
import Link from 'next/link'
import { loginPath, trialRequestUrl } from '@/lib/url'

export const EnterpriseGuide: React.FC<{ className?: string }> = (props) => {
  return (
    <div
      css={css`
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: ${colors.white00};
        padding: 56px 64px;
        justify-content: center;
        max-width: 1120px;
      `}
      className={'enterprise-guide ' + props.className}
    >
      <p
        css={css`
          margin: 0;
          margin-block-start: 36px;
          font-size: 16px;
          line-height: 1.5;
          color: ${colors.textStrong};
          text-align: center;
        `}
      >
        有料契約限定のコンテンツです。
        <br />
        無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。
      </p>
      <div
        css={css`
          margin-top: 40px;
          width: 100%;
        `}
      >
        <img src={`/static/images/enterprise/paywall.png`} />
      </div>
      <div
        css={css`
          margin-top: 56px;
          display: flex;
          flex-direction: column;
          align-items: center;
        `}
      >
        <Link href={trialRequestUrl} passHref>
          <a>
            <Button size="normal">無料トライアルに申し込む</Button>
          </a>
        </Link>
        <div
          css={css`
            margin-top: 16px;
          `}
        >
          <A
            href={loginPath}
            decoration="none"
            css={css`
              font-size: 16px;
            `}
          >
            契約済みの方はログインしてください
          </A>
        </div>
      </div>
    </div>
  )
}
